// extracted by mini-css-extract-plugin
export default {"basicInfoContainer":"AddKpiAlertBasicInformation_basicInfoContainer__QkXz+","ruleName":"AddKpiAlertBasicInformation_ruleName__vLPO5"};